export default "__VITE_ASSET__479ff189__$_?nuxt_component=async__"